export const initialNotes = [
  { message: 'Do coding challenges', checked: false },
  { message: 'Read React docs', checked: true },
  { message: 'Deploy app', checked: false },
  { message: 'Setup database', checked: true },
  { message: 'Implement e2e tests', checked: true },
];
